export default __webpack_public_path__ + "images/8fabe45cdb6ccc04100de43dde6406c0.png";